import { render } from "./IconDocumentCheck.vue?vue&type=template&id=1975df2c"
const script = {}
script.render = render

export default script